import { render } from "./IconButton.vue?vue&type=template&id=3e33f0d6"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=3e33f0d6&lang=scss"

import exportComponent from "/Users/Max/Documents/Projekte/slf-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__